import { interpolate } from './routes/interpolate';
import * as PATHS from './routes/paths';

export const admin = {
  ...PATHS.admin,
  editProject: interpolate<{ slug: string }>(PATHS.admin.editProject),
};

export const browse = {
  ...PATHS.browse,
};

export const calendar = {
  ...PATHS.calendar,
};

export const client = {
  ...PATHS.client,
  approveContractOffer: interpolate<{ slug: string }>(
    PATHS.client.approveContractOffer
  ),
  reviewTimesheetAnonymously: interpolate<{ slug: string }>(
    PATHS.client.reviewTimesheetAnonymously
  ),
  editProject: interpolate<{ slug: string }>(PATHS.client.editProject),
  projectDetails: interpolate<{ slug: string }>(PATHS.client.projectDetails),
  projectExpertsToReview: interpolate<{ code: string }>(
    PATHS.client.projectExpertsToReview
  ),
  projectExpertsToReviewSelected: interpolate<{ code: string; slug: string }>(
    PATHS.client.projectExpertsToReviewSelected
  ),
  projectTimesheets: interpolate<{ slug: string }>(
    PATHS.client.projectTimesheets
  ),
  projectContracts: interpolate<{ code: string }>(
    PATHS.client.projectContracts
  ),
  projectContractsNew: interpolate<{ slug: string }>(
    PATHS.client.projectContractsNew
  ),
  projectOffers: interpolate<{ slug: string }>(PATHS.client.projectOffers),
  projectPending: interpolate<{ slug: string }>(PATHS.client.projectPending),
  projectActive: interpolate<{ slug: string }>(PATHS.client.projectActive),
  projectTimesheetDetails: interpolate<{ invoiceCode: string }>(
    PATHS.client.projectTimesheetDetails
  ),
  contractDetails: interpolate<{ code: string; slug: string }>(
    PATHS.client.contractDetails
  ),
};

export const contacts = {
  ...PATHS.contacts,
};

export const contracts = {
  ...PATHS.contracts,
  show: interpolate<{ code: string }>(PATHS.contracts.show),
  offer: interpolate<{ code: string; slug: string }>(PATHS.contracts.offer),
};

export const expert = {
  ...PATHS.expert,
  activeProjects: interpolate<{ tab: string }>(PATHS.expert.activeProjects),
  archivedProjects: interpolate<{ tab: string; subTab: string }>(
    PATHS.expert.archivedProjects
  ),
  projectDetails: interpolate<{
    option: 'view' | 'invoices' | 'offer';
    slug: string | number;
  }>(PATHS.expert.projectDetails),
  contractDetails: interpolate<{
    projecthash: string;
    contractcode: string;
  }>(PATHS.expert.contractDetails),
};

export const explore = {
  ...PATHS.explore,
};

export const findExperts = {
  ...PATHS.findExperts,
};

export const feedback = {
  ...PATHS.feedback,
  projectClientRating: interpolate<{ hash: string }>(
    PATHS.feedback.projectClientRating
  ),
};

export const fms = {
  ...PATHS.fms,
};

export const login = {
  ...PATHS.login,
};

export const ssoLogin = {
  ...PATHS.ssoLogin,
};

export const messages = {
  ...PATHS.messages,
  thread: interpolate<{ slug: string; code: string }>(PATHS.messages.thread),
};

export const partners = {
  ...PATHS.partners,
};

export const privateTalent = {
  ...PATHS.privateTalent,
  acceptInvitation: interpolate<{ slug: string }>(
    PATHS.privateTalent.acceptInvitation
  ),
  acceptTerms: interpolate<{ slug: string | null }>(
    PATHS.privateTalent.acceptTerms
  ),
};

export const profile = {
  ...PATHS.profile,
  show: interpolate<{ slug: string }>(PATHS.profile.show),
};

export const projects = {
  ...PATHS.projects,
  show: interpolate<{ slug: string }>(PATHS.projects.show),
};

export const reports = {
  ...PATHS.reports,
};

export const resetPassword = {
  ...PATHS.resetPassword,
  update: interpolate<{ hash: string }>(PATHS.resetPassword.update),
};

export const session = {
  ...PATHS.session,
};

export const signUp = {
  ...PATHS.signUp,
};

export const application = {
  ...PATHS.application,
};

export const unsubscribe = {
  ...PATHS.unsubscribe,
};

export const availability = {
  ...PATHS.availability,
};

export const expertSettings = {
  ...PATHS.expertSettings,
};

export const verify = {
  ...PATHS.verify,
  expert: interpolate<{ hash: string }>(PATHS.privateTalent.acceptTerms),
};

export const legal = {
  ...PATHS.legal,
  show: interpolate<{ slug: string }>(PATHS.legal.show),
};
